import { W as WuiEmptyState$1, d as defineCustomElement$1 } from './p-B_QaUtT7.js';

const WuiEmptyState = WuiEmptyState$1;
const defineCustomElement = defineCustomElement$1;

export { WuiEmptyState, defineCustomElement };
